export default class PiezometerAllMeasureDto {
    constructor(obj = {}) {
        this.stationId = obj.piezometerId
        this.measures = [...obj.measures]
    }
}